import { HIDE_MODAL, ModalActionTypes, ModalState, SHOW_MODAL } from "./types"

export const showModal = (modal: ModalState): ModalActionTypes => {
	return {
		type: SHOW_MODAL,
		payload: modal
	}
}

export const hideModal = (): ModalActionTypes => {
	return {
		type: HIDE_MODAL
	}
}
